import React, { useContext } from 'react';
import { AuthContext } from '@/auth/auth.context';
import { SimpleLoading } from '@/components/loading.component';
export const GbLoading = (props) => {
    const { isAppLoading } = useContext(AuthContext);
    return isAppLoading ? <SimpleLoading /> : props.children;
};
